import React, {useContext} from "react";
import AuthContext from "context/AuthContext";
import LeafletMapAssetAndDevices from "./LeafletMapAssetAndDevices";
import AzureMapAssetAndDevices from "./azure/AzureMapAssetAndDevices";

const MapAssetAndDevicesJS = (props) => {
    const {panel} = useContext(AuthContext);
    if (panel.map_type === "az") {
        return <AzureMapAssetAndDevices {...props} />;
    }

    return <LeafletMapAssetAndDevices {...props} />;
};

export default MapAssetAndDevicesJS;
